import { createContext, useContext, useState, useEffect } from "react";

export const AuthContext = createContext();

// eslint-disable-next-line react/prop-types
export const AuthProvider = ({ children }) => {
  const [token] = useState(localStorage.getItem("token"));
  const [tax, setTax] = useState([]);
  const[currency ,setCurrency ]=useState([]);
  const [warehouse,setWarehouse] = useState([]);
  const [orgData,setOrgData] = useState([]);

  const getTax = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/tax/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

    //  console.log(response);

      if (response.ok) {
        const data = await response.json();
       // console.log(data);
        setTax(data);
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  const getWarehouse = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/warehouses/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

     // console.log(response);

      if (response.ok) {
        const data = await response.json();
       // console.log(data);
        setWarehouse(data);
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  const getCurrency  = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/currencies/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

     // console.log(response);

      if (response.ok) {
        const data = await response.json();
       // console.log(data);
        setCurrency(data);
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  const getOrgData  = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/organisation/?orgId=${localStorage.getItem("orgId")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

     // console.log(response);

      if (response.ok) {
        const data = await response.json();
       // console.log(data);
        setOrgData(data);
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  useEffect(() => {
    getTax();
    getWarehouse();
    getCurrency();
    getOrgData();
  }, []);

  return (
    <AuthContext.Provider value={{ tax,warehouse,currency,orgData }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  const authContextValue = useContext(AuthContext);
  if (!authContextValue) {
    throw new Error("useAuth used outside of the Provider");
  }
  return authContextValue;
};
